import { ApiClient, ServiceResponse, ServiceResponseNoContent } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import SaveAppDto from "../../dtos/in/saveAppDto";
import AppStatusDto from "../../dtos/out/appStatusDto";
import RegistryAppDto from "../../dtos/out/registryAppDto";
import ReportDto from "../../dtos/out/reportDto";
import IRegistryClient from "../interfaces/registryClient";

export default class RegistryClient extends ApiClient implements IRegistryClient {

    private _baseUrl: string;

    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/registry";
    }

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async registerApp(dto: SaveAppDto, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Put(this.baseUrl, `apps`, dto,accessToken);
    }

    public async updateAppStatus(appId: number, versionId: string, accessToken: string): Promise<ServiceResponse<AppStatusDto>> {
        return await super.Post(this.baseUrl, `apps/${appId}/${versionId}/status`, null, accessToken);
    }

    public async getLatestAppVersions(accessToken: string): Promise<ServiceResponse<RegistryAppDto[]>> {
        return await super.Get<RegistryAppDto[]>(this.baseUrl, `apps`, accessToken);
    }

    public async getAppVersions(appId: number, accessToken: string): Promise<ServiceResponse<RegistryAppDto[]>> {
        return await super.Get<RegistryAppDto[]>(this.baseUrl, `apps/${appId}`, accessToken);
    }

    public async getAppVersion(appId: number, versionId: string, accessToken: string): Promise<ServiceResponse<RegistryAppDto>> {
        return await super.Get<RegistryAppDto>(this.baseUrl, `apps/${appId}/${versionId}`, accessToken);
    }


    public async getAllAppAuthScopes(accessToken: string): Promise<ServiceResponse<string[]>> {
        return await super.Get<string[]>(this.baseUrl, `apps/auth-scopes`, accessToken);
    }

    public async getDependentApps(assemblyName: string, versionId: string, accessToken: string): Promise<ServiceResponse<RegistryAppDto[]>> {
        return await super.Get<RegistryAppDto[]>(this.baseUrl, `apps/${assemblyName}/${versionId}/dependents`, accessToken);
    }

    public async getAllAppReports(accessToken: string): Promise<ServiceResponse<ReportDto[]>> {
        return await super.Get<ReportDto[]>(this.baseUrl, `apps/reports`, accessToken);
    }

    public async deleteApp(appId: number, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Delete(this.baseUrl, `apps/${appId}`, accessToken);
    }

    public async deleteAppVersion(appId: number, versionId: string, accessToken: string): Promise<ServiceResponseNoContent> {
        return await super.Delete(this.baseUrl, `apps/${appId}/${versionId}`, accessToken);
    }
};


export { RegistryClient };